<template>
  <div v-if="phone_objects.length>0">
    <CRow>
      <CCol md="12">
        <div class="print_report_footer_new" v-show="false">

          <div style="width: 100%;">
            <CCardHeader>

              <CRow>
                <CCol sm="4" md="4" style="text-align: start">
<!--                  <h6>{{ $t('docCreator') }} : {{ my_branch_code() }}/{{ get_user_name() }}</h6>-->
                  <h6>{{ $t('docCreator') }} : {{ document_visitor }}/{{ date }}</h6>
                  <h6>Sign</h6>
                </CCol>
                <CCol sm="4" md="4" style="text-align: center">
                  <h6 class="pageFooter_no1"></h6>
                </CCol>
                <CCol sm="4" md="4" style="text-align: end">
                  <h6 v-if="selectedType==3">{{ $t('components.customer') }}</h6>
                  <h6 v-if="selectedType==1">{{ $t('buttons.seller') }}</h6>
                  <h6>Sign</h6>

                </CCol>
              </CRow>

            </CCardHeader>

          </div>
        </div>
        <div class="print_report_header_new">
          <CCardHeader>
            <CRow>

              <CCol sm="4" md="4" style="text-align: right">
                <!--                  <h2 >{{ get_date(new Date()) }}</h2>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: center">
                <!--                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>-->

<!--                <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
<!--                <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->
                <h6 style="font-weight: bold;" v-if="selectedType==7">{{ $t('buyFactorCurrency') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==1">{{ $t('components.buyDocument') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==0">{{ $t('PurchaseOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==0">{{ $t('SaleOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==1">{{ $t('factor') }}</h6>
<!--                <h6 style="font-weight: bold;" v-else>{{ $t('request_order') }}</h6>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: left">
                <!--                  <CImg :src="get_logo()" width="100px" height="50px"/>-->

              </CCol>
            </CRow>
            <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
              <CCol v-if="$i18n.locale=='en'" col="4">
                <table>

                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('request_order_no') }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>

              </CCol>
              <CCol v-if="$i18n.locale=='fa'" style="direction: initial" col="3">
                <table>
                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('request_order_no') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>
              </CCol>
              <CCol col="2" v-if="$i18n.locale=='en'"></CCol>
              <CCol col="3" v-if="$i18n.locale=='fa'"></CCol>
              <CCol col="6" class="text-left">

                <div>
                  <table>
                    <tr>
                      <th style="width: 400px;padding-top: 0;text-align: end" class="pr-2 pl-2">
                        <h6 class="m-0" style="font-weight: bold">{{
                            bissiness_profile.businessName
                          }}</h6>
                        <p class="m-0" style="direction: ltr;text-align: left;">{{ company_address }}</p>
                        <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                        <p class="m-0">{{ phone_objects[0].phone }}</p>
                        <p class="m-0">{{ email_objects[0].phone }}</p>
                      </th>
                      <th width="100px">
                        <CImg :src="get_logo()" width="100px" height="50px"/>
                      </th>
                    </tr>
                  </table>
                </div>

              </CCol>
            </CRow>
            <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">

            <CRow>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('billTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0"> {{ document_person }} </p>
                <!--                                <p>{{partyMobile}} </p>-->
                <p class="m-0" v-if="user_addresses[0] !=null">
                  {{ user_addresses[0].addressText }}
                  {{ user_addresses[0].cityName }}
                  {{ user_addresses[0].regionName }}
                  {{ user_addresses[0].areaRelName }}

                </p>

                <p class="m-0"> {{ user_addresses[0].postCode }}</p>
                <p class="m-0">{{ partyMobile }} </p>

              </CCol>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('shipTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0" v-if="user_addresses[1] !=null"> {{ document_person }} </p>

                <p class="m-0" v-if="user_addresses[1] !=null">
                  {{ user_addresses[1].addressText }}
                  {{ user_addresses[1].cityName }}
                  {{ user_addresses[1].regionName }}
                  {{ user_addresses[1].areaRelName }}
                </p>
<!--                <p class="m-0" v-else>-->
<!--                  {{ user_addresses[0].addressText }}-->
<!--                  {{ user_addresses[0].cityName }}-->
<!--                  {{ user_addresses[0].regionName }}-->
<!--                  {{ user_addresses[0].areaRelName }}-->
<!--                </p>-->

                <p class="m-0" v-if="user_addresses[1] !=null">
                  {{ user_addresses[1].postCode }}</p>
                <p class="m-0" v-if="user_addresses[1] !=null">
                  {{ user_addresses[1].phoneNo }}</p>

              </CCol>
            </CRow>
          </CCardHeader>

        </div>


        <CCard>


          <CCardBody class="printMe_newprinter">
            <!--                        <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary-->
            <!--                            }} </p>-->
            <!--                        <hr v-if="document_summary!=null" class="mt-0">-->
            <div style="padding:3px;border: 1px solid #000">
              <CDataTable
                  :items="product_items"
                  :fields="fields"
                  striped
                  border

                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">
                    <strong>{{ item.row_id + 1 }}</strong>

                  </td>

                </template>
                <template #name="{item}">
                  <td>
                    <strong>{{ item.productCode }} {{ item.productName }}</strong>
                  </td>
                </template>

                <template #unit="{item}">
                  <td>
                    <strong>{{ item.value }}</strong>
                  </td>
                </template>

                <template #qty="{item}">
                  <td style="text-align: right">
                    <strong v-if="selectedType==2 || selectedType==4" style="text-align: right">{{ Math.abs(item.qty) }}</strong>
                    <strong v-else style="text-align: right">{{ Math.abs(item.qty) / item.value }}</strong>
                  </td>
                </template>
                <template #productUnitName="{item}">
                  <td >
                    <strong >{{item.productUnitName }}</strong>
                  </td>
                </template>
                <template #price="{item}">
                  <td>
                    <strong style="float: right">{{ get_currency(item.price) }} </strong>
                  </td>
                </template>
                <template #totalPrice="{item}">

                  <td>
                    <strong style="float: right">{{ get_currency(item.totalPrice) }} </strong>

                  </td>

                </template>
                <template #takhfif="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.takhfif)
                      }} </strong>

                  </td>

                </template>
                <template #tax="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.tax)
                      }} </strong>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <strong>{{ item.docDesc }}</strong>

                  </td>

                </template>


              </CDataTable>


            </div>
            <CCardBody class="mb-5">
              <CRow>
                <CCol col="7">

                  <p class="mb-1" v-for="(message,index) in messages_items">{{ message.message }}</p>
                  <br>

                  <div style="bottom: 0;position: absolute;width: 100%;">
                    <hr class="m-0">

                    <p class="mb-1">{{selected_place}} | {{ $t('weightOfInvoice') }} {{ get_weight(total_weight) }} {{ $t('kg') }}</p>
                  </div>
                </CCol>
                <CCol col="5">

                  <CDataTable v-if="selectedType!=7"
                              :items="document_result_price"
                              :fields="fields_total_price"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                  <CDataTable v-if="selectedType==7"
                              :items="document_result_price"
                              :fields="fields_total_price_currency"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>
                    <template #resultPriceCurrency="{item}">
                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>
                      </td>
                      <td v-else style="text-align: right">
                        <strong
                                v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{
                          get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)
                          }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                </CCol>
              </CRow>

            </CCardBody>

          </CCardBody>
        </CCard>



      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import i18n from "../../../i18n";

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      payDueDate: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: '',
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      doc_id: '',
      doc_id_no: '',
      company_address: '',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ], fields_low: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ],
      fields_thermal: [
        // {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},

        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        // {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},

        // {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],




      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],
      fields_total_price_currency: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px'},
        {key: 'resultPriceCurrency', label: this.$t('currency'), _style: 'padding:5px;'},
        {key: 'resultPrice', label: localStorage.getItem('currency_name'), _style: 'padding:5px;'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 0,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_data: '',
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',

      phone_objects: [],
      email_objects: [],
      website_objects: [],


      messages_items: [],
      person_email: '',

      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      total_weight: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      master_id: 0,
      document_result_price: [],
      document_result_price_currency: [],
      bissiness_profile: {},
      main_address: {},

    }
  },
  props:{
    factor_master:Object,
    factor_items:Array,
    factor_result:Object,
    contact_data:Object,
    address_data:Object,
    message_data:Object,
    user_contacts:Array,
    user_addresses:Array,



  },
  mounted() {
    this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    var self = this
    setTimeout(function () {
      self.get_document_master();
      self.get_bussiness_profile();
      self.get_main_address();
      self.get_contact();

    }, 500);


  },
  created() {

  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

    'selectedType': function () {
      this.get_messages();

      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {

    get_contact() {
      var self = this;


        var content_data = self.contact_data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.phone_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.email_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.website_objects = [{phone_type: 19, phone: '', row_id: 1}]
          if (content_data.data.length) {
            self.phone_objects = []
            self.email_objects = []
            self.website_objects = []

          }
          content_data.data.forEach((val) => {
            if (val.contactType == 1) {
              self.phone_objects.push({phone: val.contactText});
            }
            if (val.contactType == 2) {
              self.email_objects.push({phone: val.contactText});

            }
            if (val.contactType == 3) {
              self.website_objects.push({phone: val.contactText});

            }


          });
        }

    },

    print() {
      // Pass the element id here
      // this.print_with_header_title('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no);
      this.print_with_header_title_height('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no, 300, 350)

      // this.$htmlToPaper('printMe');
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master() {

 var self = this;
          if (self.get_access("sale_hide_tax_off") && self.selectedType == 3) {
            self.fields.forEach(function (val, index) {
              if (val.key == 'tax') {
                self.fields.splice(index, 1);
              }
            });
            self.fields.forEach(function (val, index) {
              if (val.key == 'off') {
                self.fields.splice(index, 1);
              }
            });
          }

          self.selectedType = self.factor_master.docType
          // self.document_person = content_data.data.partyName;
          self.document_person_id = self.factor_master.partyId;
          self.date = self.factor_master.docDate;
          self.selected_place = self.factor_master.placeName;
          self.document_summary = self.factor_master.docDesc;
          self.document_visitor = self.factor_master.createdBy;
          self.document_driver = self.factor_master.toziKonande;
          self.doc_status = self.factor_master.statusId;
          self.tablo = self.factor_master.tablo;
          self.address = self.factor_master.addressText;
          self.vMobile = self.factor_master.vMobile;
          self.partyMobile = self.factor_master.partyMobile;
          self.doc_id_no = self.factor_master.masterCode;
          document.title =  self.doc_id_no;

          self.tozikonandeMobile = self.factor_master.tozikonandeMobile;
          self.payDueDate = self.factor_master.payDueDate;

          self.get_document_details();

    },
    get_document_details() {
      var self = this;


      // items = content_cats.orders;
      if(self.get_access('document_sort_product')){
        self.factor_items = self.factor_items.sort((a, b) => a.productName.localeCompare(b.productName, undefined, {numeric: true, sensitivity: 'base'}));
      }
      self.product_items = self.factor_items.map((item, row_id) => {
        return {...item, row_id}

      });

      self.total_weight = 0;
      self.product_items.forEach((val) => {
        // console.log("total weight is ",val.docWeight,val.qty,val.value)
        self.total_weight += val.docWeight * val.qty;
        if(self.selectedType==3){
          val.price = val.price*val.value

        }
        val.takhfif = val.discount
      });
      self.total_weight = self.total_weight / 1000;

      self.get_document_result();


    },

    get_document_result() {
      var self = this;


        var total = 0;
          var total_currency = 0;
          var currency_title = '';
          var total_result_off = 0
          var total_result_off_currency = 0
          var currency_title = 0
          //*********************8 merge result
          if (self.get_access("merge_price_result")) {
            self.factor_result.factorResults.filter(x=> (x.resultItemId==4 || x.resultItemId==5) && x.currencyTitle=="Base"  ).forEach(function (val) {
                total_result_off+= parseFloat(val.resultPrice.replace(/,/g, ""));
            })

          self.factor_result.factorResults.filter(x=> (x.resultItemId==4 || x.resultItemId==5) && x.currencyTitle!="Base"  ).forEach(function (val) {
            total_result_off_currency+= parseFloat(val.resultPrice.replace(/,/g, ""));
            currency_title=val.currencyTitle;
            })
            self.factor_result.factorResults = self.factor_result.factorResults.filter(x=> x.resultItemId!=4 && x.resultItemId!=5 && x.resultItemId!=6 ) ;
          }
          //*********************8 end merge result

          self.document_result_price = [];

          total = parseFloat(self.factor_result.factorResults.filter(x => x.resultItemId == 8 && x.currencyTitle == 'Base')[0].resultPrice.replace(/,/g, ""));
          if (self.selectedType == 7) {
            total_currency = parseFloat(self.factor_result.factorResults.filter(x => x.resultItemId == 8 && x.currencyTitle != 'Base')[0].resultPrice.replace(/,/g, ""));
          }
          self.factor_result.factorResults = self.factor_result.factorResults.filter(x => x.resultItemId != 8);

          self.factor_result.factorResults.forEach((val) => {

            val.resultPrice = val.resultPrice.replace(/,/g, "")
            self.document_result_price.push(val);
            if (self.get_access("merge_price_result") && val.resultItemId==3 && total_result_off>0) {
              self.document_result_price.push({currencyTitle: "Base", resultTitle: self.$t('Discounts'), resultPrice: total_result_off, resultItemId: 4});
            }
            if (self.get_access("merge_price_result") && val.resultItemId==3 && total_result_off_currency>0) {
              self.document_result_price.push({currencyTitle: currency_title, resultTitle: self.$t('Discounts'), resultPrice: total_result_off, resultItemId: 4});
            }

            if (val.currencyTitle == 'Base') {
            } else {
              currency_title = val.currencyTitle;
            }
            total_result_off=0;
            total_result_off_currency=0;
          });
          //********* check costs
var total_cost_price = 0;
var total_cost_price_currency = 0;
var total_cost_price_title = 0;
          self.factor_result.factorCosts.forEach((val) => {
            val.resultPrice = val.resultPrice.replace(/,/g, "")
            if (!self.get_access("merge_price_result")) {

              self.document_result_price.push(val);
              if (val.currencyTitle == 'Base') {
                total += parseInt(val.resultPrice.replace(/,/g, ""));
              } else {
                total_currency += parseInt(val.resultPrice.replace(/,/g, ""));
              }
            } else {
              if (val.currencyTitle == 'Base') {
                total_cost_price += parseFloat(val.resultPrice.replace(/,/g, ""));

                total += parseFloat(val.resultPrice.replace(/,/g, ""));
              } else {
                total_cost_price_currency += parseFloat(val.resultPrice.replace(/,/g, ""));
                total_cost_price_title = (val.currencyTitle);

                total_currency += parseFloat(val.resultPrice.replace(/,/g, ""));
              }
            }
          });
          if (self.get_access("merge_price_result") && total_cost_price>0) {
            self.document_result_price.push({currencyTitle: "Base", resultTitle:self.$t('Costs'), resultPrice: total_cost_price, resultItemId: 1});
            if (self.selectedType == 7) {
              self.document_result_price.push({currencyTitle: total_cost_price_title, resultTitle:self.$t('Costs'), resultPrice: total_cost_price_currency, resultItemId: 1});
            }
          }
//***********************************


          var obj = {
            currencyTitle: 'Base',
            final_price: true,
            resultTitle: self.$t('factorTotalPrice'),
            resultPrice: total,
            resultPriceCurrency: total_currency,
            resultPriceCurrencyTitle: currency_title,
          }
          self.document_result_price.push(obj);

          if (self.selectedType == 7) {
            self.document_result_price_currency = JSON.parse(JSON.stringify(self.document_result_price));
            self.document_result_price = self.document_result_price.filter(x => x.currencyTitle == "Base");

          }

          self.get_user_data();



    },
    get_messages() {
      var self = this;

      const formData = new FormData();

        var content_data = self.message_data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.messages_items = content_data.data.filter(x => x.docTypeId == self.selectedType);

        }

    },

    get_user_data() {

      let self = this;

        //
        // self.document_person_data = res.data.data;
        // var person = res.data.data.person;

        self.document_person = self.factor_master.personCode
        self.document_person += " " + self.factor_master.partyName
        if (self.factor_master.middelName != null) {
          self.document_person += " " + self.factor_master.middelName
        }
        if (self.factor_master.surName != null) {
          self.document_person += " " + self.factor_master.surName
        }
        if( self.user_contacts.filter(x => x.contactType == 18).length>0){
          self.person_email = self.user_contacts.filter(x => x.contactType == 18)[0].contact

        }


    },

    get_bussiness_profile() {
       document.getElementById("logo_image").src = localStorage.getItem("app_logo")

    },
    get_main_address() {
      var self = this;

        var content_data = self.address_data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.main_address = content_data.data

          if (self.$i18n.locale == 'fa') {
            self.company_address = self.main_address.cityName + " " + self.main_address.street + " " + self.main_address.houseNO + " " + self.main_address.postCode;

          } else {
            self.company_address = self.main_address.houseNO + " " + self.main_address.street + " " + self.main_address.cityName + " " + self.main_address.postCode;

          }


        }
    },

  }

}

</script>
